
import { defineComponent, PropType } from 'vue'
import { iFilter, iLayer } from '../../LayersManagement'
import layersManagementFilterTabDescriptor from './LayersManagementFilterTabDescriptor.json'
import Listbox from 'primevue/listbox'

export default defineComponent({
    name: 'layers-management-filter-tab',
    components: { Listbox },
    props: { selectedLayer: { type: Object as PropType<iLayer>, required: true }, propFilters: { type: Array as PropType<iFilter[]> } },
    emits: ['touched'],
    data() {
        return {
            layersManagementFilterTabDescriptor,
            layer: null as iLayer | null,
            filters: [] as iFilter[]
        }
    },
    watch: {
        selectedLayer() {
            this.loadLayer()
            this.loadFilters()
        },
        propFilters() {
            this.loadFilters()
        }
    },
    created() {
        this.loadLayer()
        this.loadFilters()
    },
    methods: {
        loadLayer() {
            this.layer = this.selectedLayer
        },
        loadFilters() {
            this.filters = []
            this.propFilters?.forEach((filter: iFilter) => {
                const index = this.layer?.properties.findIndex((property: iFilter) => property.property === filter.property)
                if (index === -1) this.filters.push(filter)
            })
        },
        addProperty(filter: iFilter) {
            this.moveProperty(filter, this.filters, this.layer?.properties)
        },
        removeProperty(filter: iFilter) {
            this.moveProperty(filter, this.layer?.properties, this.filters)
        },
        moveProperty(filter: iFilter, sourceList, targetList) {
            const index = sourceList.findIndex((tempFilter: iFilter) => tempFilter.property === filter.property)
            if (index !== -1) {
                targetList.push(filter)
                sourceList.splice(index, 1)
                this.$emit('touched')
            }
        }
    }
})
